import QueryString from 'query-string';
import { toastr } from 'react-redux-toastr';
import { CLEAR_BUS_WAIT_TIME_VIOLATIONS, FLAG_GETTING_BUS_WAIT_TIME_VIOLATIONS, GET_BUS_WAIT_TIME_VIOLATIONS } from '../types';
import { isErrorResponse } from '../../utils/error-handlers';
import { DEFAULT_GET_CONFIG } from '../../config/rest';
import { BUS_WAIT_TIME_VIOLATION_ENDPOINT } from '../../config/endpoints';

const flagGettingBusWaitTimeViolations = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_BUS_WAIT_TIME_VIOLATIONS,
    payload: flag,
  });

const getBusWaitTimeViolations = async ({
  fromDateString, toDateString
}) => async (dispatch) => {
  try {
    dispatch(flagGettingBusWaitTimeViolations(true));
    const query = {
      fromDateString,
      toDateString
    }
    const url = `${BUS_WAIT_TIME_VIOLATION_ENDPOINT}?${QueryString.stringify(query)}`;

    const response = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(response, null, dispatch);
    const busWaitTimeViolations = await response.json();
    dispatch({
      type: GET_BUS_WAIT_TIME_VIOLATIONS,
      payload: busWaitTimeViolations,
    });
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagGettingBusWaitTimeViolations(false));
  }
}

const clearBusWaitTimeViolations = () => (dispatch) =>
  dispatch({
    type: CLEAR_BUS_WAIT_TIME_VIOLATIONS,
  });

export {
  getBusWaitTimeViolations,
  clearBusWaitTimeViolations,
}